import { BottomSheetTextInput } from '@gorhom/bottom-sheet'
import { IS_WEB } from 'constants/platform'
import { useTheme } from 'contexts'
import React from 'react'
import { StyleSheet } from 'react-native'

import { Box } from 'widgets/Box'
import { ControlProps } from 'widgets/Field/types'
import { Icon } from 'widgets/Icon'
import { Pressable } from 'widgets/Pressable'

import { StyledTextInput } from './styled'

export const ChatInputAction = ({
  action,
  inputProps,
  value,
  disabled,
  isBottomSheetPresentation = false,
}: {
  action: () => void
  inputProps?: Partial<ControlProps>
  disabled?: boolean
  value: string
  isBottomSheetPresentation?: boolean
}) => {
  const theme = useTheme()

  const styles = StyleSheet.create({
    bottomSheetTextInput: {
      height: 38,
      color: theme.colors.black,
      fontSize: theme.fonts.sizes.sm + 1,
    },
  })

  let inputField = (
    <Box padding={{ horizontal: 'smd' }}>
      <BottomSheetTextInput
        value={value}
        {...inputProps}
        style={styles.bottomSheetTextInput}
        onChange={(e) => inputProps?.onChange(e?.nativeEvent?.text ?? '')}
      />
    </Box>
  )

  if (IS_WEB || !isBottomSheetPresentation) {
    inputField = <StyledTextInput value={value} {...inputProps} />
  }

  return (
    <Box
      flexDirection='row'
      height={44}
      border={{ color: 'v2primary', width: 2 }}
      borderRadius='lg'
      align='center'
    >
      <Box flex={1}>{inputField}</Box>
      <Pressable onPress={action} disabled={disabled}>
        <Box
          width={32}
          height={32}
          margin={{ horizontal: 'xs' }}
          borderRadius='lg'
          justifyContent='center'
          align='center'
          backgroundColor={disabled ? 'grey' : 'v2primary'}
        >
          <Icon size={22} color='black' name='arrow-right' />
        </Box>
      </Pressable>
    </Box>
  )
}
